export default __webpack_public_path__ + "assets/images/2.00d57f.png";